import { render, staticRenderFns } from "./CouponGroupRecord.vue?vue&type=template&id=492c533c&"
import script from "./CouponGroupRecord.vue?vue&type=script&lang=js&"
export * from "./CouponGroupRecord.vue?vue&type=script&lang=js&"
import style0 from "./CouponGroupRecord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports